const prefix = 'DimNegotiationCase';

export enum DimNegotiationCaseMeasure {
  COUNT = `${prefix}.count`,
}

export enum DimNegotiationCaseDimension {
  ID = `${prefix}.id`,
  CREATED_AT = `${prefix}.createdAt`,
  UPDATED_AT = `${prefix}.updatedAt`,
  SEQUENCE_NUMBER = `${prefix}.sequenceNumber`,
  STATUS = `${prefix}.status`,
  PROCESS_STATUS = `${prefix}.processStatus`,
  IS_RELEASABLE = `${prefix}.isReleasable`,
  NEGOTIATION_BOUNDARY_LOWER = `${prefix}.negotiationBoundaryLower`,
  NEGOTIATION_BOUNDARY_UPPER = `${prefix}.negotiationBoundaryUpper`,
  DEMAND_ID = `${prefix}.demandId`,
  SUPPLIER_ID = `${prefix}.supplierId`,
  CREATED_BY_ID = `${prefix}.createdById`,
  RESPONSIBLE_USER_ID = `${prefix}.responsibleUserId`,
  NEGOTIATION_CASE_ID = `${prefix}.negotiationCaseId`,
  TOTAL_VALUE = `${prefix}.totalValue`,
}
